import React, { FC, useCallback } from 'react';
import { FormattedMessage } from 'react-intl';
import { useHistory } from 'react-router';
import { TextButton } from '../../../../components/common';
import { MainSource } from '../../../../constants/Source';
import { useTrackSearchAndFiltersAnalytics } from '../../../../utils/hooks/bi/useTrackSearchAndFiltersAnalytics';
import { ClickOriginsSearchAndFiltersClear } from '../../../../utils/hooks/bi/useTrackSearchAndFiltersAnalytics/useTrackSearchAndFiltersAnalytics.types';
import { isAllSource } from '../../../../utils/media-manager-sdk/sources';
import { RouteBuilder } from '../../../../utils/RouteHelpers';
import { IOuter } from '../EmptyState.types';

export const ResetSearchButton: FC<IOuter> = ({ source, currentFolder }) => {
  const { trackSearchAndFiltersClear } = useTrackSearchAndFiltersAnalytics();
  const history = useHistory();

  const clearSearch = useCallback(() => {
    trackSearchAndFiltersClear(ClickOriginsSearchAndFiltersClear.Search);
    history.push(
      RouteBuilder.Source(isAllSource(source) ? MainSource.SiteFiles : source, currentFolder && currentFolder.id),
    );
  }, [history, source, currentFolder, trackSearchAndFiltersClear]);

  return (
    <TextButton
      as="a"
      size={window.isNewColorsBrandingEnabled ? 'small' : 'medium'}
      onClick={clearSearch}
      dataHook="clear-search-button"
    >
      <FormattedMessage id="empty-state.clear-search" />
    </TextButton>
  );
};
